<template>
  <div class="regional_set">
    <div class="top_background"></div>
    <div class="set_main">
      <div class="set_area">
        <div class="area_top">
          <p>区域</p>
          <button @click="areaMaskshow('add')" v-if="permisShow('区域新增')">添加区域</button>
        </div>
        <ul class="area_list">
          <li class="area_list_item region_hover" :class="{active:isTure == index}" v-for="(item,index) in regionData"
            :key="index">
            <span class="area_text" @click="regionClick(index,item.areaId)">{{item.name}}</span>
            <span>
              <i class="iconfont icon-icon_bianji" v-if="permisShow('区域编辑')"
                @click="areaMaskshow('edit',item.areaId,item.name)"></i>
              <i class="iconfont icon-icon_shanchu" v-if="permisShow('区域删除')" @click="removeAdd(item.areaId)"></i>
            </span>
          </li>
        </ul>
        <p class="area_prompt">仅允许次级为空的区域选项被删除，如果删除某个区域请清空次级商圈内容</p>
      </div>
      <div class="set_circle set_area">
        <div class="area_top">
          <p>商圈</p>
          <button v-if="permisShow('商圈新增')" @click="circleMaskshow('add')">添加商圈</button>
        </div>
        <div class="area_inp">
          <!-- <el-input v-model="areacont" placeholder="请输入内容" @change="searchTradearea"></el-input> -->
          <el-input type="text" name v-model="areacont" @input="searchTradearea">
            <i slot="suffix" class="iconfont iconsousuo"></i></el-input>
        </div>
        <ul class="area_list">
          <li class="area_list_item area_hover" :class="{area_active:isTrue2 == index}" v-for="(item,index) in areaData"
            :key="index">
            <span class="area_text" @click="areaClick(index)">{{item.tradeAreaName}}</span>
            <span>
              <i v-if="permisShow('商圈编辑')" class="iconfont icon-icon_bianji"
                @click="circleMaskshow('edit',item.tradeAreaName,item.tradeAreaId)"></i>
              <i v-if="permisShow('商圈删除')" class="iconfont icon-icon_shanchu"
                @click="removeAreaBtn(item.tradeAreaId)"></i>
            </span>
          </li>
        </ul>
        <p class="area_prompt">仅允许次级为空的区域选项被删除，如果删除某个区域请清空次级商圈内容</p>
      </div>
      <el-dialog :title="areaMasktitle" :visible.sync="addArea" @close="resetForm('ruleForm')">
        <p class="dialog_title">区域名称（必填）</p>
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="demo-ruleForm">
          <el-form-item prop="name">
            <el-input v-model="ruleForm.name" placeholder="请输入区域名称"></el-input>
          </el-form-item>
        </el-form>
        <div class="area_btns">
          <button class="area_save" @click="submitForm('ruleForm')">保存</button>
          <button class="area_cancel" @click="resetForm('ruleForm')">取消</button>
        </div>
      </el-dialog>
      <el-dialog :title="circleMasktitle" :visible.sync="addCircle" @close="resetCircleForm('circleRuleForm')">
        <h3>所属区域</h3>
        <el-select disabled="disabled" v-model="circleForm.areaId" placeholder="请选择">
          <el-option v-for="(item,index) in regionData" :key="index" :label="item.name" :value="item.areaId">
          </el-option>
        </el-select>
        <p class="dialog_title">商圈名称（必填）</p>
        <el-form :model="circleForm" :rules="cirfleRules" ref="circleRuleForm" class="demo-ruleForm">
          <el-form-item prop="name">
            <el-input v-model="circleForm.name" placeholder="请输入商圈名称"></el-input>
          </el-form-item>
        </el-form>
        <div class="area_btns">
          <button class="area_save" @click="submitCircleCircle('circleRuleForm')">保存</button>
          <button class="area_cancel" @click="resetCircleForm('circleRuleForm')">取消</button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script type="text/javascript">
import {
  areaAdd,
  areaQuery,
  areaUpdate,
  areaDelet,
  tradeareaAdd,
  tradeareaDelet,
  tradeareaUpdate,
  tradeareaQuery
} from "@/api/manageCenter.js";

export default {
  name: "regional_set",
  data() {
    let permisList = JSON.parse(sessionStorage.getItem("permisList"));
    return {
      permisList,
      isTure: 0,
      isTrue2: -1,
      areaId: "",
      regionData: [],
      areaData: [],
      addArea: false,
      areaMasktitle: "",
      addCircle: false,
      circleMasktitle: "",
      value: "",
      areacont: "",
      ruleForm: {
        name: "",
        areaId: ""
      },
      circleForm: {
        areaId: "",
        name: "",
        tradeAreaId: ""
      },
      rules: {
        name: [
          {
            required: true,
            message: "请输入区域名称",
            trigger: "blur"
          }
          // { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
        ]
      },
      cirfleRules: {
        tradeAreaName: [
          {
            required: true,
            message: "请输入新增商圈名称",
            trigger: "change"
          }
        ]
      }
    };
  },
  mounted() {
    // this.employeeId = sessionStorage.getItem('employeeId')
    this.getRegionData();
    let params = {
      areaId: this.areaId
    };
    this.getAreaData(params);
  },
  methods: {
    permisShow(data) {
      // 权限配置
      let result = this.permisList.indexOf(data);
      if (result >= 0) {
        return true;
      } else {
        return false;
      }
    },
    areaMaskshow(title, id, name) {
      this.addArea = true;
      if (title === "add") {
        this.areaMasktitle = "新增区域";
        this.ruleForm.name = "";
        this.ruleForm.areaId = "";
      } else {
        this.areaMasktitle = "编辑区域";
        this.ruleForm.name = name;
        this.ruleForm.areaId = id;
      }
    },

    getRegionData() {
      // 获取区域
      let params = {
        // name: data
      };
      this.$post(areaQuery, params).then(res => {
        if (res.success) {
          this.regionData = res.data;
          this.areaId = res.data[0].areaId;
          let params = {
            areaId: this.areaId
          };
          this.getAreaData(params);
        } else {
          this.$message({
            type: "error",
            message: res.msg
          });
        }
      });
    },

    removeAdd(iD) {
      // 删除区域
      this.$confirm("确认删除吗", "提示", {
        type: "warning"
      }).then(() => {
        let params = {
          areaId: iD
        };
        this.$post(areaDelet, params).then(res => {
          if (res.success) {
            this.$message({
              message: res.msg,
              type: "success"
            });
            this.getRegionData();
          } else {
            // alert(111);
            this.$message({
              message: res.msg,
              type: "error"
            });
          }
        });
      });
    },

    submitForm(formName) {
      // 添加区域
      this.$refs[formName].validate(valid => {
        if (valid) {
          let params = this.ruleForm;

          if (this.areaMasktitle === "新增区域") {
            this.$post(areaAdd, params).then(res => {
              if (res.success) {
                this.$message({
                  message: "添加成功",
                  type: "success"
                });

                this.addArea = false;
                this.getRegionData();
              } else {
                this.$message({
                  message: res.msg,
                  type: "error"
                });
              }
            });
          } else {
            this.$post(areaUpdate, params).then(res => {
              if (res.success) {
                this.$message({
                  message: res.msg,
                  type: "success"
                });
                this.addArea = false;
                this.getRegionData();
              } else {
                this.$message({
                  message: res.msg,
                  type: "error"
                });
              }
            });
          }
        } else {
          return false;
        }
      });
    },

    getAreaData(params) {
      // 获取商圈
      this.$post(tradeareaQuery, params).then(res => {
        if (res.success) {
          this.areaData = res.data;
        } else {
          this.$message({
            message: res.msg,
            type: "error"
          });
        }
      });
    },

    searchTradearea() {
      // 精确搜索商圈
      let params = {
        areaId: this.areaId,
        tradeAreaName: this.areacont
      };
      this.getAreaData(params);
    },

    regionClick(index, id) {
      // 点击区域获取商圈
      this.isTure2 = -1;
      this.isTure = index;
      this.areaId = id;
      this.circleForm.areaId = id;
      let params = {
        areaId: id
      };
      this.getAreaData(params);
    },

    removeAreaBtn(tradeAreaId) {
      // 删除商圈
      this.$confirm("确认删除吗", "提示", {
        type: "warning"
      }).then(() => {
        let params = {
          areaId: this.areaId,
          tradeAreaId: tradeAreaId
        };
        this.$post(tradeareaDelet, params).then(res => {
          if (res.success) {
            this.$message({
              message: res.msg,
              type: "success"
            });
            let params = {
              areaId: this.areaId
            };
            this.getAreaData(params);
          } else {
            this.$message({
              message: res.msg,
              type: "error"
            });
          }
        });
      });
    },
    areaClick(i) {
      this.isTrue2 = i;
    },

    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.addArea = false;
    },

    circleMaskshow(data, name, id) {
      this.addCircle = true;
      if (data === "add") {
        this.circleMasktitle = "新增商圈";
        this.circleForm.areaId = this.areaId;
        this.circleForm.name = "";
        this.circleForm.tradeAreaId = "";
      } else {
        this.circleMasktitle = "编辑商圈";
        this.circleForm.name = name;
        this.circleForm.tradeAreaId = id;
      }
    },

    submitCircleCircle(formName) {
      // 新增商圈
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (!this.circleForm.name) {
            this.$message({
              message: "商圈名称不能为空",
              type: "error"
            });
            return;
          }
          let params = this.circleForm;
          if (this.circleMasktitle === "新增商圈") {
            this.$post(tradeareaAdd, params).then(res => {
              if (res.success) {
                this.$message({
                  message: "添加成功",
                  type: "success"
                });

                this.addCircle = false;
                let params = {
                  areaId: this.areaId
                };
                this.getAreaData(params);
              } else {
                this.$message({
                  message: res.msg,
                  type: "error"
                });
              }
            });
          } else {
            this.$post(tradeareaUpdate, params).then(res => {
              if (res.success) {
                this.$message({
                  message: "修改成功",
                  type: "success"
                });

                this.addCircle = false;
                let params = {
                  areaId: this.areaId
                };
                this.getAreaData(params);
              } else {
                this.$message({
                  message: res.msg,
                  type: "error"
                });
              }
            });
          }
        } else {
          return false;
        }
      });
    },
    resetCircleForm(formName) {
      this.$refs[formName].resetFields();
      this.addCircle = false;
      this.circleForm.regionId = "";
    }
  }
};
</script>
<style type="text/css" lang="less">
.regional_set {
  height: 100%;
  display: flex;
  flex-direction: column;
  .el-dialog {
    width: 300px;

    .el-dialog__header {
      .el-dialog__title {
        color: #5e75e6;
        font-size: 20px;
      }

      .el-dialog__headerbtn .el-dialog__close {
        font-size: 24px;
      }
    }

    .el-dialog__body {
      padding: 20px 0 0 0;

      > h3 {
        font-size: 14px;
        color: #333333;
        padding: 0 20px;
      }

      .dialog_title {
        font-size: 14px;
        color: #333333;
        padding: 0 20px;
      }

      .el-select {
        margin-top: 10px;
        margin-bottom: 20px;
        padding: 0 20px;

        .el-input__icon {
          line-height: 30px;
        }
      }

      .el-form,
      .el-select {
        margin-top: 10px;
        padding: 0 20px;

        .el-input__inner {
          width: 230px;
          height: 30px;
          background: #f5f5f5;
          border: 1px solid #cccccc;
        }
      }

      .area_btns {
        height: 80px;
        background: #f5f5f5;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        margin-top: 40px;

        > button {
          width: 80px;
          height: 40px;
          border-radius: 4px;
          outline: none;
          border: none;
          font-size: 16px;
          color: white;

          &.area_cancel {
            margin-right: 20px;
            background: #999999;
          }

          &.area_save {
            margin-right: 40px;
            background: #5e75e6;
          }
        }
      }
    }
  }
  .top_background {
    height: 20px;
  }

  .set_main {
    overflow: hidden;
    overflow-y: scroll;
    background: white;
    flex: 1;
    // margin-bottom: 50px;
    box-shadow: 0px 3px 6px #eee;
    display: flex;

    .set_area {
      width: 400px;
      height: 600px;
      border: 1px solid #5e75e6;
      box-sizing: border-box;

      .area_top {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 30px 20px 0 40px;

        > p {
          font-size: 20px;
          color: #5e75e6;
          font-weight: 600;
        }

        > button {
          width: 100px;
          height: 40px;
          border: none;
          outline: none;
          background: #f5f5f5;
          color: #5e75e6;
          border-radius: 4px;
        }
      }

      .area_list {
        margin-top: 10px;
        border-bottom: 1px solid #f5f5f5;
        overflow: hidden;
        overflow-y: scroll;
        height: 400px;

        .area_list_item {
          display: flex;
          justify-content: space-between;
          height: 40px;
          align-items: center;
          border-top: 1px solid #f5f5f5;
          padding-right: 20px;
          font-size: 14px;
          color: #666666;

          .area_text {
            flex: 1;
            height: 100%;
            line-height: 40px;
            padding-left: 40px;
            margin-right: 10px;
          }

          .iconfont {
            font-size: 26px;
            color: #5e75e6;
          }

          &.active {
            background: #5e75e6;
            color: white;

            .iconfont {
              color: white;
            }
          }
        }

        .region_hover:hover {
          background: #5e75e6;
          color: white;

          .iconfont {
            color: white;
          }
        }

        .area_hover:hover {
          background: #999999;
          color: white;

          .iconfont {
            font-size: 26px;
            color: white;
          }
        }
      }

      .area_prompt {
        margin-top: 20px;
        font-size: 14px;
        color: #cccccc;
        padding: 0 30px;
        line-height: 22px;
      }
    }

    .set_circle {
      border: none;
      border-right: 1px solid #f5f5f5;

      .area_top {
        > p {
          color: #999999;
        }

        > button {
          color: #999999;
        }
      }

      .area_inp {
        margin-top: 40px;
        margin-left: 40px;
        position: relative;

        .el-input {
          .el-input__suffix {
            position: relative !important;
            right: 30px;
          }
          .el-input__inner {
            width: 230px;
            height: 30px;
            padding-left: 35px;
            border-radius: 4px;
          }
        }

        // .icon-icon_sousuo {
        //   position: absolute;
        //   font-size: 20px;
        //   left: 10px;
        //   top: 5px;
        //   color: #999999;
        // }
      }

      .area_list {
        .area_list_item {
          .iconfont {
            font-size: 26px;
            color: #999999;
          }

          &.area_active {
            background: #999999;
            color: white;

            .iconfont {
              color: white;
            }
          }
        }
      }
    }
  }
}
</style>
